export type SiteSwitcherSelection = {
	label: string;
	/** value is not expected to be undefined for cloudId */
	value: string | null | undefined;
	url?: string;
} | null;

export const RELATED_RESOURCES_SITE_SWITCHER_LOCAL_STORAGE_KEY = 'related-resources-site-switcher';
